import { render, staticRenderFns } from "./HeaderGlobalSearch.vue?vue&type=template&id=74023e49&scoped=true"
import script from "./HeaderGlobalSearch.vue?vue&type=script&lang=js"
export * from "./HeaderGlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./HeaderGlobalSearch.vue?vue&type=style&index=0&id=74023e49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74023e49",
  null
  
)

export default component.exports